import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export class EnergieWaermequelle extends BaseModel {
    // properties
    id: number | null = null;
    i18n_key: string | null = null;
    code: number | null = null;
    bezeichnung: string | null = null;

    getClassName(): string {
        return 'EnergieWaermequelle';
    }
}

export class EnergieWaermequelleCollection extends BaseCollection<EnergieWaermequelle> {
    protected modelCls = EnergieWaermequelle;

    public getModelClassName(): string {
        return 'EnergieWaermequelle';
    }
}

let _globalEnergieWaermequelleCollection: EnergieWaermequelleCollection | null = null;

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalEnergieWaermequelleCollection(): EnergieWaermequelleCollection {
    if (!_globalEnergieWaermequelleCollection) {
        _globalEnergieWaermequelleCollection = new EnergieWaermequelleCollection();
        _globalEnergieWaermequelleCollection.setQueryParams({
            sort: [
                {
                    property: 'code',
                    direction: 'asc',
                },
                {
                    property: 'id',
                    direction: 'asc',
                },
            ],
        });
        _globalEnergieWaermequelleCollection.query();
    }
    return _globalEnergieWaermequelleCollection;
}
